import ListItem from "@mui/material/ListItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import Checkbox from "@mui/material/Checkbox";
import ListItemText from "@mui/material/ListItemText";
import React, {useEffect} from "react";
import ListComponenttype from "./ListComponenttype";

function ItemComponenttype({data, index, labelId, currentObjectTypeId, setCurrentObjectTypeId, setCurrentObjectType, handleClick, showAttributes, setShowAttributes, showAttributesSub, setShowAttributesSub, checkedAttributes, setCheckedAttributes, theRealm}) {

    useEffect(() => {
        if (currentObjectTypeId === index) {
            setShowAttributes(true);
        }
    }, [index, currentObjectTypeId, setShowAttributes]);

    const showChildren = data?.children_objecttypes?.length > 0;

    return (
        <>
            <ListItem key={index} role="listitem" button onClick={(e) => handleClick(index, data)}>
                <ListItemIcon>
                    <Checkbox
                        checked={currentObjectTypeId === data?.objecttype_id}
                        tabIndex={-1}
                        disableRipple
                        inputProps={{'aria-labelledby': labelId}}
                    />
                </ListItemIcon>
                <ListItemText id={labelId} primary={<span>{`${data?.code} - ${data?.name}`}</span>}/>
            </ListItem>
            {showChildren
                ? <ListComponenttype
                    items={data?.children_objecttypes}
                    currentObjectTypeId={currentObjectTypeId}
                    setCurrentObjectTypeId={setCurrentObjectTypeId}
                    showAttributes={showAttributesSub}
                    setShowAttributes={setShowAttributesSub}
                    setCurrentObjectType={setCurrentObjectType}
                    checkedAttributes={checkedAttributes}
                    setCheckedAttributes={setCheckedAttributes}
                    theRealm={theRealm}/>
                : null}
        </>
    );
}

export default ItemComponenttype;
